// react
import { type ReactNode, useEffect, useState } from 'react';

// relative
import {
  type ColorMode,
  ColorModeContext,
  type ColorModeContextValue,
} from '../contexts/ColorModeContext';

const getPersistedMode = (): ColorMode => {
  const savedMode = localStorage.getItem('mode');
  return savedMode === 'dark' ? 'dark' : 'light';
};

/**
 * Owns the light/dark mode state, persists it to localStorage, and exposes
 * it app-wide via context so components (e.g. `SettingsMenu`) can read
 * and toggle the mode without prop drilling.
 */
export default function ColorModeProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [mode, setMode] = useState(getPersistedMode);

  const toggleColorMode = () => {
    setMode((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  useEffect(() => {
    localStorage.setItem('mode', mode);
  }, [mode]);

  const value: ColorModeContextValue = { mode, toggleColorMode };

  return (
    <ColorModeContext.Provider value={value}>
      {children}
    </ColorModeContext.Provider>
  );
}
